import { Component, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';

import { NavigationStart, Router } from '@angular/router';

import { SeoService } from './shared/global-store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private seoService: SeoService,
  ) {}

  public ngOnInit(): void {
    this.router.events.subscribe((event): void => {
      if (event instanceof NavigationStart) {
        if (!!event.url && event.url.match(/^\/#/)) {
          this.router.navigate([event.url.replace('/#', '')]);
        }
      }
    });

    this.seoService.generateTags({
      title: 'Vinlivt Business | Mein Vinlivt Business',
    });
  }

  public ngOnDestroy(): void {}
}
